

import { toggleModal, ADD_TEAM_TO_LIST, UPDATE_TEAM_IN_LIST, DELETE_TEAM_FROM_LIST, ADD_TEAMS_TO_LIST } from "./mutation-types";

export default {

        [toggleModal]: (state, value) =>{
            state.isShowAddOrUpdateModal = value;
        },

        [ADD_TEAMS_TO_LIST]: (state, teamsList) =>{
            state.teamsList = teamsList ;
        },
        
        [ADD_TEAM_TO_LIST]: (state, team) =>{
            state.teamsList.push(team);
        },

        [UPDATE_TEAM_IN_LIST]: (state, updatedTeam) =>{
            const index = state.teamsList.findIndex(team => team.id === updatedTeam.id);
            state.teamsList[index] = updatedTeam
        },

        [DELETE_TEAM_FROM_LIST]: (state, teamIDs) => {
            state.teamsList.forEach((element, index) => { 
                teamIDs.forEach(id=>{
                     if( id == element.id || id === element.id){
                        state.teamsList.splice(index, 1);
                     }
                        
                });
            });

          },
          
}
